import { render, staticRenderFns } from "./RsaPazienteMainPage.vue?vue&type=template&id=5b5ac667"
import script from "./RsaPazienteMainPage.vue?vue&type=script&lang=js"
export * from "./RsaPazienteMainPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports